import { connect } from 'react-redux'
import { UnitProvider } from 'shared/units'
import { selectUnitPreference } from 'services/user/selectors'
import { selectLanguageCode } from 'services/bootup/selectors'

const mapIntlStateToProps = (state) => ({
  locale: selectLanguageCode(state),
  system: selectUnitPreference(state),
})

export default connect(mapIntlStateToProps)(UnitProvider)



// WEBPACK FOOTER //
// ./src/application/root/UnitProvider.jsx